
import { OPERATION_ID } from "./request"
import Stream from "../frp/stream"
import { postpone } from 'utils'
import ServerTool, { TYPE } from './server_tool'
import Space from 'frp/space'

export default class DullServer extends ServerTool
{
    constructor( gameId, name, bonusSettings, totalizator, space )
    {
        super()
        
        this.gameId = gameId;
        this.name = name;
        this.bonusSettings = bonusSettings;
        this.totalizator = totalizator
        this.space = space

        space.s( 'progressive_jackpot' ).next( { enabled : false } )
        
        space.s( 'login' )
            .with(
                space.s( 'spec' ),
                space.s( 'balance' ),
                space.s( 'state' ),
                ( _, spec, balance, state ) => ({
                    spec,
                    balance,
                    state,
                    settings : {
                        features : {
                            bet_auto_restore : true,
                            can_session_close : true,
                            session_long_life : false,
                        },
                        user : { nickname : "iru3" },
                    },
                })
            )
            .do( loginData => this.loginData = loginData )
            .map( ({ spec, balance, state }) => ({
                balance,
                server : this,
                state : {
                    type : state.stage.type_id,
                    server : this,
                    state,
                },
            }) )
            .to( space.s( 'handle_lobby' ) )
        space.s( 'handle_lobby' ).to( space.s( 'net' ) )
            
        space.s( 'state' )
            .do( state => this.lastState = state )
        
        space.s( 'balance' )
            .do( balance => this.balance = balance )
            .to( space.s( 'balance_poll' ) )
    }
    
    ready_to_play(){}
    first_request(){}
    handleLobby(){}
    spin(){}
    freespin(){}
    enterRisk(){}
    takeWin(){}
    chooseAtRisk(){}
    proceedBonus(){}
    goNextStage(){}
    goNextStage(){}
    goNextStage(){}
    finish(){}
    goNextStage(){}

    login(
        url,
        username,
        password,
        onLogin,
        onFail,
        onFatal,
        options,
        debug_project_name,
        spinCase
    ){}

    handleLobby(
        onResult,
        onFail,
        onFatal,
        options
    )
    {
        this.space.s( 'handle_lobby' )
            .take( 1 )
            .on( onResult )
        
        setTimeout(
            () => this.space.s( 'login' ).next(),
            1
        )
    }
}

export function dull_server( space )
{
    space.s( 'login' )
        .map( () => ({
            id : 208,
            code_name : "HoneyGalaxy",
            name : "HoneyGalaxy",
            lines_array : [1,5,10,15,20],
            bets_array : [1,2,3,4,5,10,20,50,100],
            specification : {
                freeSpinWinMultiplier : 1,
                linesAdjustment : ["left"],
                linesCountMax : 20,
                linesPaths : [[1,1,1,1,1],[0,0,0,0,0],[2,2,2,2,2],[0,1,2,1,0],[2,1,0,1,2],[1,0,0,0,1],[1,2,2,2,1],[0,0,1,2,2],[2,2,1,0,0],[1,0,1,2,1],[1,2,1,0,1],[0,1,1,1,0],[2,1,1,1,2],[0,1,0,1,0],[2,1,2,1,2],[1,1,0,1,1],[1,1,2,1,1],[0,0,2,0,0],[2,2,0,2,2],[0,2,2,2,0]],
                priceList : [[0,0,20,100,1000,9000],[0,0,2,30,100,1500],[0,0,0,25,80,500],[0,0,0,20,60,300],[0,0,0,15,50,200],[0,0,0,15,50,200],[0,0,0,10,40,100],[0,0,0,10,40,100],[0,0,0,10,40,100],[0,0,0,5,20,100],[0,0,0,0,0,0]],
                scatterWinCoeffs : [0,0,0,5,20,100],
                substitutableElements : [1,2,3,4,5,6,7,8,9],
                symbolBonus : 10,
                symbolScatter : 10, 
                symbolWild : 0,
                symbolsCount : 11,
                wildLineWinMultiplier : 1,
            },
            stage_type_map : {"1":"MAIN","2":"FINAL","3":"FREE","7":"FEATURE_END","8":"JACKPOT","9":"PRECURSOR"},
            risks : [
                {
                    type_id : 1,
                    specification : {
                        nominals : [ "2","3","4","5","6","7","8","9","10","J","Q","K","A" ],
                        riskId : 1,
                        suitNames : [ "hearts","diamonds","spades","clubs" ],
                        visualizationVariants : [ "Red", "Black" ],
                    },
                    stage_type_map : {
                        "10" : "RISK_MAIN",
                        "12" : "RISK_RESULT_RED",
                        "13" : "RISK_RESULT_BLACK",
                    },
                },
            ],
        }) )
        .name( space, 'spec_login' )
        .to( space.s( 'spec' ) )
    
    space.s( 'login' )
        .with( space.s( 'spec' ), space.s( 'state' ), ( _, spec, state ) => ({ spec, state }) )
    
    const currency = {
        code_name : "RUB",
        delimiter : '.',
        id : 643,
        minor_unit : 2,
        visible : true,
    }
    
    space.s( 'login' )
        .map( () => ({
            cashable : 10000,
            cashable_money : 1000000,
            credit_price : 100,
            currency,
            demo : true,
            gameable : 10000,
            gameable_limit : 900000000,
            gameable_money : 1000000,
        }) )
        .name( space, 'balance_login' )
        .to( space.s( 'balance' ) )
    
    space.s( 'login' )
        .map( () => ({
            credit_price : 100,
            currency,
            line_count : 1,
            multiplier : 1,
            open_win : 0,
            open_win_money : 0,
            stage : {
                math : {
                },
                type_id : TYPE.BONUS_1,
            },
            way_map : [ TYPE.BONUS_1 ],
        }) )
        .name( space, 'state_login' )
        .to( space.s( 'state' ) )
}






// WEBPACK FOOTER //
// ./src/library/network/dull_server.es6